import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SocketContext } from 'shared/contexts/socket/socket-context';
import OperatorExtension from 'store/slice/call-detail/types';
import { RootState } from 'store/store';

import TransferredOperator from './transferred-operator';

const TransferHistoryContainer = () => {
  const socket = useContext(SocketContext);
  const currentUserExtension = useSelector((state: RootState) => state.loggedInUser.userPhone);
  const [currentUser, setCurrentUser] = useState<OperatorExtension | null>(null);

  useEffect(() => {
    socket?.emit('get-operators', (operatorExtensions: OperatorExtension[]) => {
      const currentOperator = operatorExtensions.find((_operator) => _operator.userExtension === currentUserExtension);
      if (currentOperator) setCurrentUser(currentOperator);
    });
  }, [currentUserExtension]);

  return currentUser ? (
    <>
      <div className="pr-6 pl-1 h-[38rem] overflow-y-scroll soft-scrollbar">
        <TransferredOperator
          imageUrl={currentUser?.imageUrl || ''}
          name={currentUser?.fullName || ''}
          role={currentUser?.teamName || ''}
          status="در حال مکالمه"
        />
      </div>
    </>
  ) : null;
};

export default TransferHistoryContainer;
